import { render, staticRenderFns } from "./CompensatingFactors.vue?vue&type=template&id=c470da98&"
import script from "./CompensatingFactors.vue?vue&type=script&lang=js&"
export * from "./CompensatingFactors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports